import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./ProjectCard.css";

function ProjectCard({ project }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="project-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => navigate(`/projects/${project.id}`)}
    >
      <img
        src={project.image}
        alt={project.title}
        className={`project-card__img ${hovered ? "project-card__img--zoom" : ""}`}
      />
      <div className={`project-card__overlay ${hovered ? "project-card__overlay--dark" : ""}`} />

      <div className="project-card__content">
        <span className="badge">{t(`projects_data.${project.id}.category`, project.category)}</span>
        <h3 className="project-card__title">{t(`projects_data.${project.id}.title`, project.title)}</h3>
        <p className={`project-card__desc ${hovered ? "project-card__desc--visible" : ""}`}>
          {t(`projects_data.${project.id}.short`, project.short)}
        </p>
        <span className={`project-card__link ${hovered ? "project-card__link--visible" : ""}`}>
          {t("projects_page.button")}
        </span>
      </div>
    </div>
  );
}

export default ProjectCard;
